
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.679","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.285 0h1.124c.43.091.859.146 1.271.274a6.549 6.549 0 014.717 6.234 1.09 1.09 0 01-.823 1.106 1.127 1.127 0 01-1.38-1.188 4.352 4.352 0 00-8.684-.274c-.064 1.207-.018 2.422-.018 3.638 0 .009.009.027.037.064h11.626a2.423 2.423 0 012.514 2.386c.018 3.857.009 6.508 0 10.366a2.418 2.418 0 01-1.618 2.239 7.02 7.02 0 01-.484.155H2.109c-.1-.027-.192-.064-.293-.091a2.42 2.42 0 01-1.81-2.3c-.009-3.857-.009-6.508 0-10.366a2.4 2.4 0 012.029-2.349c.393-.055.814-.046 1.234-.064v-.283c0-1.033-.009-2.057 0-3.1A6.514 6.514 0 017.721.378C8.243.2 8.775.119 9.285 0z","fill":"#3a3a3a"}})])
          )
        }
      }
    